<template>
  <div>
    <Head title="Energy Managers" />
    <!-- <span class="group flex items-center py-3 mb-6">
      <icon name="users" class="mr-4 w-8 h-8 text-gray-700"/>
      <h1 class="text-3xl font-bold">Review</h1>
    </span>  -->

    <div class="flex items-center py-4 bg-gray-50 border-t border-gray-100">
          <h1 style="width: 100%;" class="w-100 mt-6 pb-10 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" :href="`/issues/${issues.id}/edit`"><small>Kembali</small></Link>
            <span class="text-indigo-400 font-medium"> |</span> Ulasan Aduan <span class="text-sm pl-8">( Status Aduan : {{ getCurrentProcess(issues.current_stat, issues) }} )</span>
            <!-- <span v-if="issues_id !== 'draft'" class="text-indigo-200 ml-8"><small>( Draft Saved )</small></span> -->
          </h1> 

          <button class="btn-indigo cursor-pointer flex items-center px-6 py-4 mr-8 focus:text-indigo-500" @click="generateCertificate('JMM-FORM')">
            <icon name="adobe" class="mr-2 w-4 h-4 fill-white" />
            Borang Tindakan JMMM
          </button>

          <a v-if="owner" class="btn-indigo cursor-pointer flex items-center pl-6 py-4 focus:text-indigo-500" @click="complaintStatus()">
            <icon name="process" class="mr-2 w-4 h-4 fill-white" />Status Aduan
          </a>


    </div>     

    <br />

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Nama Pengadu</th>
            <th class="pb-4 pt-6 px-6">Tarikh/Masa Kejadian</th>
            <th class="pb-4 pt-6 px-6">Tempat Kejadian</th>
            <th class="pb-4 pt-6 px-6">Keterangan Aduan</th>
            <th class="pb-4 pt-6 px-6">Maklumat Tambahan</th>
          </tr>
        </thead>
        <tbody>
        <tr class="hover:bg-gray-100 focus-within:bg-gray-100 text-xl">
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500" >
                {{ issues.name }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500" >
                {{ formatDate(issues.date_incident, 'partial') }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500" >
                {{ issues.location }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500" >
                {{ issues.details }}              
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500" >          
                
                 <!-- {{ issues.uploads }} -->
<!-- parent exists only when individuals OR uploads exist -->
<div v-if="(issues.individuals && issues.individuals.length) || (issues.uploads && issues.uploads.length)" class="space-y-4">
  <!-- Individuals (only shown when it has items) -->
  <div v-if="issues.individuals && issues.individuals.length">
    <p class="mb-2 font-semibold">Orang Yang Di Adu</p>
    <ul class="list-disc list-inside mb-2">
      <li v-for="item in issues.individuals" :key="item.id">
        <span v-html="item.name"></span>
      </li>
    </ul>
  </div>

  <!-- Attachments (only shown when it has items) -->
  <div v-if="issues.uploads && issues.uploads.length">
    <p class="mb-2 font-semibold">Dokumen atau Fail</p>
    <ul>
      <li v-for="item in issues.uploads" :key="item.id">
        <a @click="loadAttachment('file_attached', item.upload_path)"
           class="text-xl cursor-pointer flex items-center">
          <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
          View Document
        </a>
      </li>
    </ul>
  </div>
</div>
<!-- {{ issues.status.process }} -->
              </span> 
            </td>
          </tr>          
        </tbody>
      </table>
    </div>
    
</div>

    <div class="bg-white rounded-md overflow-hidden">
      
    <div class="bg-gray-300 pb-4 pt-6 px-6 text-center font-bold text-2xl mt-12 mb-10">
      Ulasan Jawatankuasa Menilai Maklumat (JMM) 
    </div>      

    <Editor
      v-model="form.details"
      api-key="vqjrkkz5kuubpfviailv5r0z92h5x7hnmld9d1vhve70scmw"
      :init="editorInit"
    />

    <div class="flex flex-wrap py-8">
      <div class="w-full">
        <label class="block text-xl font-medium text-gray-700 mb-2">Tarikh Ulasan JMM : {{ tarikh_ulasan }}</label>
        <Datepicker 
          class="pt-4 lg:w-1/2"
          v-model="form.date_review" 
          format="dd-MM-yyyy"
          @closed="runme()"
          placeholder="Tarikh Ulasan JMM"
        />
      </div>
    </div>       

    <div class="flex items-center pb-6 bg-gray-50 border-t border-gray-100">
      <!-- Right group: Submit Complaint -->
      <div class="mr-auto">
        <button class="btn-action cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="submitReview('reviews')"> 
          <icon name="save" class="mr-4 w-4 h-4 bf-w fill-white"/>Simpan Ulasan
        </button> 
      </div>
    </div>      
    

    <div class="bg-gray-300 pb-4 pt-6 px-6 font-bold text-2xl mt-12">
      Bersama ini dilampirkan satu salinan maklumat / aduan mengenai perkara di atas. Jawatankuasa Menilai Maklumat (JMM) telah membuat keputusan seperti berikut :
      <p><small>(sila tandakan [/] yang berkaitan)</small></p>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6 text-center" colspan="4">Kategori Aduan</th>
        </tr>
        <tr v-for="(pair, rowIndex) in chunkedCategories" :key="rowIndex" class="text-left">
          <!-- First action -->
          <td
            class="pb-4 pt-6 px-6 text-left"
            :class="{ 'font-bold': isCategoryActive(pair[0]?.id) }"
          >
            {{ pair[0]?.action }}
          </td>
          <td class="pb-4 pt-6 px-6 text-center">
            <Vue3ToggleButton
              class="float-right"
              @on-change="toggleCatergory(pair[0])"
              :is-active="isCategoryActive(pair[0]?.id)"
              :trackColor="'#ccc'"
              :track-active-color="'#d9efe0'"
              :handleColor="'#2f5a5b'"
            />
          </td>

          <!-- Second action -->
          <td
            class="pb-4 pt-6 px-6 text-left"
            :class="{ 'font-bold': isCategoryActive(pair[1]?.id) }"
          >
            {{ pair[1]?.action }}
          </td>
          <td class="pb-4 pt-6 px-6 text-center">
            <Vue3ToggleButton
              class="float-right"
              @on-change="toggleCatergory(pair[1])"
              :is-active="isCategoryActive(pair[1]?.id)"
              :trackColor="'#ccc'"
              :track-active-color="'#d9efe0'"
              :handleColor="'#2f5a5b'"
            />
          </td>
        </tr> 
      </table>
    </div>

    <div class="bg-gray-300 pb-4 pt-6 px-6 text-center font-bold text-2xl mt-12">
      Keputusan / Tindakan
    </div>    

    <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6 text-center" colspan="4"><!-- Keputusan / Tindakan --></th>
        </tr>
        <tr v-for="(pair, rowIndex) in chunkedActions" :key="rowIndex" class="text-left">
          <!-- First action -->
          <td
            class="pb-4 pt-6 px-6 text-left"
            :class="{ 'font-bold': isActionActive(pair[0]?.id) }"
          >
            {{ pair[0]?.action }}
          </td>
          <td class="pb-4 pt-6 px-6 text-center">
            <Vue3ToggleButton
              class="float-right"
              @on-change="toggleAction(pair[0])"
              :is-active="isActionActive(pair[0]?.id)"
              :trackColor="'#ccc'"
              :track-active-color="'#d9efe0'"
              :handleColor="'#2f5a5b'"
            />
          </td>

          <!-- Second action -->
          <td
            class="pb-4 pt-6 px-6 text-left"
            :class="{ 'font-bold': isActionActive(pair[1]?.id) }"
          >
            {{ pair[1]?.action }}
          </td>
          <td class="pb-4 pt-6 px-6 text-center">
            <Vue3ToggleButton
              class="float-right"
              @on-change="toggleAction(pair[1])"
              :is-active="isActionActive(pair[1]?.id)"
              :trackColor="'#ccc'"
              :track-active-color="'#d9efe0'"
              :handleColor="'#2f5a5b'"
            />
          </td>
        </tr> 
      </table>
    </div>

    <div class="bg-gray-300 pb-4 pt-6 px-6 text-center font-bold text-2xl mt-12 mb-10">
      Catatan Keputusan / Tindakan 
    </div>      

    <Editor
      v-model="form.notes"
      api-key="vqjrkkz5kuubpfviailv5r0z92h5x7hnmld9d1vhve70scmw"
      :init="editorInit"
    />

     
    <div class="flex items-center py-8 pb-6 bg-gray-50 border-t border-gray-100">
      <!-- Right group: Submit Complaint -->
      <div class="mr-auto">
        <button class="btn-action cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="submitReview('notes')"> 
          <icon name="save" class="mr-4 w-4 h-4 bf-w fill-white"/>Simpan Catatan
        </button> 
      </div>
    </div>       

    <Modal @close="closeProcessForm" :modalActive="modalProcess" @submit="closeProcessForm" submitLabel="Kembali">
      <div class="mx-6">
        <h1 class="text-2xl font-bold">📜&nbsp;Kemaskini Status Aduan</h1>
                  
        <!-- process -->  
        <div class="flex items-center justify-between mt-4 p-4 bg-gray-100 rounded">
          <text-input v-model="form.message" :error="form.errors.message" class="pb-4 pr-4 w-full" label="Catatan" />
          <select-input @change="changeStatus" v-model="form.status" :error="form.errors.status" class="pb-4 pr-6 w-full lg:w-1/2" label="Status ">
            <option v-for="operation in operations" :key="operation" :value="operation">{{ operation }}</option>
          </select-input>
          <loading-button :loading="form.processing" class="btn-action ml-auto" type="button" @click="updateSubmission">💬&nbsp;Kemaskini Status</loading-button>
        </div>
      
      </div>
    </Modal>     
    
    </div>

</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import { ref } from "vue";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import { Vue3ToggleButton } from 'vue3-toggle-button'
import '../../../../node_modules/vue3-toggle-button/dist/style.css'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import Modal from "@/Shared/Modal.vue"
import axios from 'axios'
import moment from 'moment'
import Editor from '@tinymce/tinymce-vue';

export default {
  components: {
    Head,
    Icon,
    Link,
    SelectInput,
    TextInput,
    Vue3ToggleButton,
    Modal,
    Datepicker,
    Editor,
  },
  layout: Layout,
  props: {
    issues: Object,
    issues_category: {
      type: Array,
      default: () => []
    },
    issues_actions: {
      type: Array,
      default: () => []
    },   
    owner: {
      type: [Object, Boolean],
      default: () => false
    }
  },
  data() {
    return {
      form: this.$inertia.form({
        issue_id: this.issues.id,
        date_submit : '',
        details: '', // make sure details is defined
        message: '',
        notes : '',
        date_review : '',
      }),
      operations : [],
      editorInit: {
        height: 400,
        menubar: false,
        toolbar:
          'undo redo | formatselect | bold italic backcolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | removeformat | help',
        content_style:
          'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      },
      issues_category: this.issues.issues_category,
      issues_actions: this.issues.issues_actions,
      tarikh_ulasan : "[not-set]", 
    }
  },
  computed: {
    chunkedCategories() {
      const result = []
      for (let i = 0; i < this.issues.category.length; i += 2) {
        result.push(this.issues.category.slice(i, i + 2))
      }
      return result
    },
    chunkedActions() {
      const result = []
      for (let i = 0; i < this.issues.actions.length; i += 2) {
        result.push(this.issues.actions.slice(i, i + 2))
      }
      return result
    }  
  },
  mounted(){ 

    let workflow = this.issues.workflows;
    workflow.forEach((item) => {
      if(item.process == 'submit')
      this.form.date_submit = this.formatDate(item.created_at, 'full');     
    });

    let action = this.issues.action;
    action.forEach((item) => {
      this.operations.push(item.action)      
    });
    this.progress = this.operations

   if(this.issues.reviews.length>0){
    this.form.details = this.issues.reviews[0].remarks; 
   }

   if(this.issues.notes.length>0){
    this.form.notes = this.issues.notes[0].remarks; 
   }

   

   if(this.issues.reviewed){
    this.form.date_review = this.issues.reviewed.remarks
    this.tarikh_ulasan = this.formatDate(this.issues.reviewed.remarks)  
   }
   
  },
  setup() {
    const modalProcess = ref(false); 

    const toggleProcess = () => {
      modalProcess.value = !modalProcess.value;
    };

    return { modalProcess, toggleProcess };
  },   
  methods: {
    complaintStatus(){
      this.toggleProcess()
    },
    closeProcessForm(){
      this.form.errors.status = "";
      this.toggleProcess()
    },
    updateSubmission(){
      
      if (typeof this.form.status === 'undefined') {
        this.form.errors.status = "no status selected";
        return;
      }
      
      this.form.processing = true;
      
      const data = {
        target_id: this.issues.id,
        status: this.form.status,
        message: this.form.message,
      };
      
      axios.post(`/issues/${this.issues.id}/workflows`, data)
        .then(response => {
          this.form.processing = false
          if(response.data.status == 'success'){
            this.toggleProcess()
            this.$page.props.flash.success = response.data.message
          }
        })
        .catch(error => { });

    },         
    isCategoryActive(categoryId) {
      return this.issues_category.some(
        item => Number(item.process) === Number(categoryId)
      )
    },
    toggleCatergory(category) {
        const idx = this.issues_category.findIndex(
          (item) => Number(item.process) === Number(category.id)
        )
        let process = "";
        if (idx >= 0) {
          // already active → remove it
          this.issues_category.splice(idx, 1)
          process = "remove";
        } else {
          // not active → add it
          this.issues_category.push({
            user_id: this.user_id, // or however you store it
            modules: category.modules,
            target_id: this.target_id, // whatever context you have
            process: category.id,
            remarks: "",
          })
          process = "add";
        }

      const data = {
        target_id: this.issues.id,
        review: 'category',
        action: process,
        target: category.id,
      };
      
      axios.post(`/issues/${this.issues.id}/process`, data)
        .then(response => {

        })
        .catch(error => { });        
        
    },
     isActionActive(categoryId) {
      return this.issues_actions.some(
        item => Number(item.process) === Number(categoryId)
      )
    },
    toggleAction(category) {
        const idx = this.issues_actions.findIndex(
          (item) => Number(item.process) === Number(category.id)
        )

        let process = "";
        if (idx >= 0) {
          // already active → remove it
          this.issues_actions.splice(idx, 1)
          process = "remove";
        } else {
          // not active → add it
          this.issues_actions.push({
            user_id: this.user_id, // or however you store it
            modules: category.modules,
            target_id: this.target_id, // whatever context you have
            process: category.id,
            remarks: "",
          })
          process = "add";
        }

        const data = {
          target_id: this.issues.id,
          review: 'actions',
          action: process,
          target: category.id,
        };
        
        axios.post(`/issues/${this.issues.id}/process`, data)
          .then(response => {

          })
          .catch(error => { });  
        
    },
    submitReview(actions){

        let reviews = "";
        let details = "";
        let review_date =  moment(this.form.date_review).format("yyyy-MM-DD");
        
        if(actions=="reviews"){
          reviews = "review";
          details = this.form.details;
        }
      
        if(actions=="notes"){
          reviews = "note";
          details = this.form.notes;
        }

        const data = {
          target_id: this.issues.id,
          review: reviews,
          action: actions,
          target: details,
          date_review : review_date,
        };
                  
        axios.post(`/issues/${this.issues.id}/process`, data)
        .then(response => {
          this.form.processing = false
          if (response.data.status === 'success') {
            this.$page.props.flash.success = response.data.message
          setTimeout(() => {
              this.$inertia.reload({ preserveScroll: true })
            }, 2500) // 2500 ms = 2.5 seconds
          }
        })

    },
    runme(){

    },
    generateCertificate(target){

      const formData = new FormData();
      formData.append('issue_id', this.issues.id);
      formData.append('date_submit', this.form.date_submit);
      
      this.$inertia.post(`/reports/${this.issues.id}/generate/${target}`, formData, {
        preserveState: false,
        preserveScroll: true,
      })        
        
           
    },                
    formatDate(timestamp, format){
      if(format=="full"){
        return moment(timestamp).format("DD-MM-YYYY hh:mm A");
      } else {
        return moment(timestamp).format("DD-MM-YYYY");
      }
    },
    loadAttachment(attachment, upload){

      let target = "";

      if(attachment=='file_attached'){
        target = upload;
      }
      
      window.open(target, '_blank');    
    },
    getCurrentProcess(curr_stat, issue){
      
      let actions = issue.action;
      let currentProcess = actions.find(item => item.action === curr_stat) || { action_label: "draf" };
      
      return currentProcess.action_label.toUpperCase()
    }          
  },
}
</script>
